// src/services/maintenanceRequestService.js
// Wraps /api/maintenance-requests/* backend calls.

import { api } from './api';

export const maintenanceRequestService = {
  create: (data) =>
    api.post('/api/maintenance-requests/', data),

  getAll: (status) =>
    api.get('/api/maintenance-requests/' + (status ? '?status=' + status : '')),

  getMy: () =>
    api.get('/api/maintenance-requests/my'),

  approve: (requestId, comments) =>
    api.put('/api/maintenance-requests/' + requestId + '/approve', { comments }),

  reject: (requestId, comments) =>
    api.put('/api/maintenance-requests/' + requestId + '/reject', { comments }),
};